enum keys {
  alertModalKey = "adminalertModalKey",
  adminDataKey = "adminadminDataKey",
  loadingKey = "adminloadingKey",
}

export default keys;
